import { noteValueType } from '@/entities/templates';

import { NOTE_VALUE_TYPE_SETTINGS, type NoteFieldSetting } from '../config';

import { isNoteBlockMultiple, type NoteBlockDef } from './noteView';

// Scribe's `NoteBlock.AllowsSetting`, which owns the rule: a setting the
// field's value type allows, except that a field the record fills takes only
// its slot id and its link, and a choice takes the dictation rule only when
// it takes several values. The parity test holds both to one table.
export const noteAllowsSetting = (
  block: NoteBlockDef,
  setting: NoteFieldSetting,
) => {
  const valueType = noteValueType(block);
  if (!valueType || !NOTE_VALUE_TYPE_SETTINGS[valueType].includes(setting)) {
    return false;
  }
  if (block.Kind.case === 'Context') {
    return setting === 'slot_id' || setting === 'link';
  }
  if (setting === 'dictation_rule' && valueType === 'choice') {
    return isNoteBlockMultiple(block);
  }
  return true;
};

// Scribe's `NoteBlock.AIFills`: a field the AI steps fill, the one that takes
// an AI instruction of its own. The AI tools have a shape for every value
// type that allows AI fill.
export const noteAIFills = (block: NoteBlockDef) =>
  noteAllowsSetting(block, 'ai_fill');
